/** Strings of the project overview: activity feed, charts, service buttons and the Discord meeting invite. */
export const projOverviewEn = {
  projActivity: {
    title: "Activity",
    types: {
      journal: "Changes",
      comment: "Comments",
      time_entry: "Time logged",
      sync_job: "Syncs",
    },
    typeAria: "Activity type",
    userAria: "Activity user",
    sortAria: "Activity sort order",
    allTypes: "All types",
    allUsers: "All users",
    unnamed: "(unnamed)",
    newestFirst: "Newest first",
    oldestFirst: "Oldest first",
    loading: "Loading…",
    empty: "No activity found.",
    system: "System",
    view: "View",
  },
  projOverview: {
    created: "Created",
    byStatus: "Issues by status",
    byPriority: "Issues by priority",
    velocity: "Velocity (closed / week)",
    hoursThisMonth: "Hours this month",
    noEntries: "No entries.",
    openWorkItems: "Open work items",
    viewAll: "View all",
    noOpenWorkItems: "No open work items.",
    recentTimeEntries: "Recent time entries",
    noTimeEntries: "No time entries.",
    externalUser: "External user",
    overhead: "Project overhead",
  },
  projServiceButtons: {
    vault: "Open project secrets in Vault",
    seafile: "Open project files in Seafile",
    gitlab: "Open in GitLab",
  },
  projMeeting: {
    title: "Meetings",
    intro:
      "Invite Hubert into a Discord voice channel — he records the call, transcribes it, and what he proposes about this project lands in the queue above.",
    invite: "Invite Hubert",
    dialogTitle: "Invite Hubert to a Discord call",
    loadingChannels: "Loading channels…",
    sttMissing:
      "Speech-to-text is not configured — set <code>STT_API_KEY</code> on the server first.",
    voiceChannel: "Voice channel",
    joining: "Joining…",
    joinRecord: "Join & record",
    botNotConfigured: "The Discord bot is not configured (DISCORD_BOT_TOKEN).",
    listFailed: "Couldn't list voice channels.",
    startFailed: "Couldn't start the recording.",
    status: {
      scheduled: "Scheduled",
      joining: "Connecting…",
      recording: "Recording…",
      processing: "Transcribing & analysing…",
      completed: "Completed",
      failed: "Failed",
      cancelled: "Cancelled",
    },
    started: "started",
    noAudio: "no audio for {{count}} min",
    stop: "Stop & analyse",
    utterances_one: "{{count}} utterance",
    utterances_few: "{{count}} utterances",
    utterances_other: "{{count}} utterances",
    incomplete: "Incomplete recording",
    failed: "Failed",
    viewAnalysis: "view analysis",
    retry: "Retry",
    transcribeAgain: "Transcribe again",
  },
};

export const projOverviewCs: typeof projOverviewEn = {
  projActivity: {
    title: "Aktivita",
    types: {
      journal: "Změny",
      comment: "Komentáře",
      time_entry: "Zapsaný čas",
      sync_job: "Synchronizace",
    },
    typeAria: "Typ aktivity",
    userAria: "Uživatel aktivity",
    sortAria: "Řazení aktivity",
    allTypes: "Všechny typy",
    allUsers: "Všichni uživatelé",
    unnamed: "(bez jména)",
    newestFirst: "Nejnovější první",
    oldestFirst: "Nejstarší první",
    loading: "Načítání…",
    empty: "Žádná aktivita.",
    system: "Systém",
    view: "Zobrazit",
  },
  projOverview: {
    created: "Vytvořeno",
    byStatus: "Tikety podle stavu",
    byPriority: "Tikety podle priority",
    velocity: "Rychlost (uzavřeno / týden)",
    hoursThisMonth: "Hodiny tento měsíc",
    noEntries: "Žádné záznamy.",
    openWorkItems: "Otevřené tikety",
    viewAll: "Zobrazit vše",
    noOpenWorkItems: "Žádné otevřené tikety.",
    recentTimeEntries: "Poslední časové záznamy",
    noTimeEntries: "Žádné časové záznamy.",
    externalUser: "Externí uživatel",
    overhead: "Režie projektu",
  },
  projServiceButtons: {
    vault: "Otevřít tajné klíče projektu ve Vaultu",
    seafile: "Otevřít soubory projektu v Seafile",
    gitlab: "Otevřít v GitLabu",
  },
  projMeeting: {
    title: "Schůzky",
    intro:
      "Pozvěte Huberta do hlasového kanálu na Discordu — hovor nahraje, přepíše a to, co k tomuto projektu navrhne, skončí ve frontě výše.",
    invite: "Pozvat Huberta",
    dialogTitle: "Pozvat Huberta do hovoru na Discordu",
    loadingChannels: "Načítání kanálů…",
    sttMissing:
      "Převod řeči na text není nastavený — nejdřív na serveru nastavte <code>STT_API_KEY</code>.",
    voiceChannel: "Hlasový kanál",
    joining: "Připojování…",
    joinRecord: "Připojit a nahrávat",
    botNotConfigured: "Discord bot není nastavený (DISCORD_BOT_TOKEN).",
    listFailed: "Nepodařilo se načíst hlasové kanály.",
    startFailed: "Nahrávání se nepodařilo spustit.",
    status: {
      scheduled: "Naplánováno",
      joining: "Připojování…",
      recording: "Nahrává se…",
      processing: "Přepis a analýza…",
      completed: "Dokončeno",
      failed: "Selhalo",
      cancelled: "Zrušeno",
    },
    started: "zahájeno",
    noAudio: "žádný zvuk už {{count}} min",
    stop: "Zastavit a analyzovat",
    utterances_one: "{{count}} promluva",
    utterances_few: "{{count}} promluvy",
    utterances_other: "{{count}} promluv",
    incomplete: "Neúplný záznam",
    failed: "Selhalo",
    viewAnalysis: "zobrazit analýzu",
    retry: "Zkusit znovu",
    transcribeAgain: "Přepsat znovu",
  },
};
